import {FormInputElement} from "./formInputElement";
import {customElement, property} from "lit/decorators.js";
import type {Maybe} from "../../../bootstrap/common/types";
import {type PropertyValues} from "lit";

@customElement("eop-form-hidden-field")
export class EopFormHiddenField extends FormInputElement<string> {

    @property({attribute: "hidden-value"})
    public hiddenValue: string;

    public constructor() {
        super("");
    }

    protected updated(changedProperties: PropertyValues): void {
        super.updated(changedProperties);
        if (changedProperties.has("hiddenValue")) {
            this.updateValue(this.hiddenValue);
        }
    }

    protected preset(): Maybe<string> {
        return "";
    }

    public focusInput(): void {

    }
}